<ng-container *ngIf="orgUser$ | async as user">
    <div class="row px-5 pb-3 pt-4">
        <div class="col-md-6 dashboard-title-section">
                <h1 class="headline-4">Dashboard</h1>
                <div class="d-flex"> 
                    @if (orgLogoUrl !== '') {
                        <img [src]="orgLogoUrl"
                         class="dashboard-logo" alt='Card image cap'>  
                    }
                    <p class="headline-6">{{user?.name}}</p>
                </div>
                <p class="body-2 m-0" [innerHTML]="user?.purpose"></p>
                <app-read-more *ngIf="user?.desc" [text]="user?.desc" class="body-3"></app-read-more>
        </div>
        <div class="col-md-5 ml-auto">
            <div class="d-flex align-items-center flex-column m-auto" style="width: 136px;">
                <span class="headline-6 mb-2">All Campaigns</span>
                <a class="campaign__qr-code mb-3" [href]="pledgeUrl" target="_blank" >
                    <img class="images" [src]="orgQRCode" />
                    <img src="images/powered_paybee.png" />
                </a>
                <app-shared-link-popover class="dashboard-campaign__action" [name]='user?.name'></app-shared-link-popover>
                <button
                    type="button"
                    class="campaign__action dashboard-campaign__action btn btn--paybee btn--outline-transparent mt-2"
                    style="border-color: #D8D8D8 !important;color: black;"
                    (click)="onDownloadQr(user)"
                >
                    <span>QR Code</span>
                    <i class="fas fa-download ml-1"></i>
                </button>
            </div>
        </div>
      </div>
</ng-container>

